export default __webpack_public_path__ + "static/media/Times-New-Roman-bold-italic.b5988560.ttf";